import React, { useReducer, useEffect, useState } from "react";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import Context, { Actions } from "./reducers/Context";
import SignupModal from "./reducers/signup/Signup";
import CloseButton from "./components/CloseButton";
import Stages from "./stages/signup";
import Stage from "./components/Stage";
import { getStorageData } from "./utils";

// const Stage = lazy(() => import("./components/Stage/Stage"));

const SignupApp = () => {
  const [initialised, setInitialised] = useState(false);
  const [state, dispatch] = useReducer(SignupModal, {
    currentStage: Stages[1],
    direction: "next"
  });

  useEffect(() => {
    (async () => {
      const sd = await getStorageData();
      if (sd.user) {
        dispatch({
          type: Actions.RECEIVED_STORED_USER_DETAILS,
          payload: { user: sd.user, sid: sd.sid }
        });
        dispatch({
          type: Actions.TO_STAGE,
          payload: { toStage: "logged-in" }
        });
      }
      setInitialised(true);
    })();
  }, []);

  const onCloseClicked = e => {
    window.tsUtilityModals.signupCancelCallback();
    dispatch({
      type: Actions.CANCELLED_SIGNUP
    });
  };

  return (
    initialised && (
      <div id="ts-signup-modal">
        <Context.Provider value={{ state, dispatch }}>
          <CloseButton onCloseClicked={onCloseClicked} />
          <TransitionGroup className={"afs-msm-stages " + state.direction}>
            <CSSTransition
              key={state.currentStage.id}
              classNames={"stage"}
              timeout={500}
            >
              <Stage {...state.currentStage} hideHeader={state.hideHeader} />
            </CSSTransition>
          </TransitionGroup>
        </Context.Provider>
        {/*<div style={{*/}
        {/*position: "fixed",*/}
        {/*bottom: 0,*/}
        {/*left: 0,*/}
        {/*right: 0,*/}
        {/*color: "lightblue",*/}
        {/*background: "black",*/}
        {/*maxHeight: "100px",*/}
        {/*overflow: "auto"*/}
        {/*}}>*/}
        {/*{process.env.REACT_APP_ENV === 'dev' && <pre style={{textAlign: "left"}}>*/}
        {/*{JSON.stringify(state, null, 2)}*/}
        {/*</pre>}*/}
        {/*</div>*/}
      </div>
    )
  );
};

export default SignupApp;
